import { useContext } from "react"
import { VerEnviosIzzaContext } from "./VerEnviosIzzaContext"

export function useVerEnviosIzzaContext() {
    return useContext(VerEnviosIzzaContext)
}
